import React from "react";
import BackButton from "./BackButton";

function ThankYou() {
  return (
    <div className="landingPage">
      Thank you for registering. A member of the See it Be it team will be in
      touch shortly
      <br />
      <BackButton />
    </div>
  );
}

export default ThankYou;
